export function transition(elem: any, styleProps: any) {
  if (!elem) {
    return Promise.resolve(null);
  }
  return new Promise((resolve) => {
    function handleTransitionEnd() {
      elem.removeEventListener("transitionend", handleTransitionEnd);
      resolve(elem);
    }
    elem.addEventListener("transitionend", handleTransitionEnd);
    Object.entries(styleProps).forEach(([prop, value]) => {
      elem.style.setProperty(prop, value);
    });
  });
}

export function animate(elem: any, animationClass: any) {
  if (!elem) {
    return Promise.resolve(null);
  }
  return new Promise((resolve) => {
    function handleAnimationEnd() {
      elem.classList.remove(animationClass);
      elem.removeEventListener("animationend", handleAnimationEnd);
      resolve(elem);
    }
    elem.addEventListener("animationend", handleAnimationEnd);
    elem.classList.add(animationClass);
  });
}
